/**
 * Super simple decorator for the localStorage api
 */
export default class Cache {
  constructor(key) {
    this.$storage = localStorage
    this.$key = key

    if (!this.$storage.getItem(this.$key)) this.set({})
  }

  get() {
    return JSON.parse(this.$storage.getItem(this.$key))
  }

  set(value) {
    this.$storage.setItem(this.$key, JSON.stringify(value))
  }
}
